<template lang="pug">
  #app
    Header
    main.main
      transition(name="slide-fade" mode="out-in")
        router-view
    Footer
    PodcastPlayer
    transition(name="top-fade" mode="out-in")
      Menu(v-if="config.menu")
</template>
<script>

import { mapActions, mapState } from 'vuex'
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import PodcastPlayer from '@/components/PodcastPlayer'
import Menu from '@/components/Menu'

export default {
  components: {
    Header,
    Footer,
    PodcastPlayer,
    Menu
  },
  data(){
    return {
      timer: false,
      moving: false
    }
  },
  methods: {
    ...mapActions([
      'setMoving'
    ]),
    startTimer(){
      this.timer = window.setTimeout(this.goInactive, 200)
    },
    resetTimer(){
      window.clearTimeout(this.timer)
      this.goActive()
    },
    goInactive(){
      this.moving = false
    },
    goActive(){
      this.moving = true
      this.startTimer()
    },
    changed(){
      // console.log('changed')
    }
  },
  watch: {
    'moving': function(val){
      this.setMoving(val)
    }
  },
  mounted(){
    document.addEventListener('mousemove', this.resetTimer)
     document.addEventListener('scroll', this.resetTimer)
  },
  computed: {
    ...mapState([
      'config'
    ])
  }

};
</script>
<style lang="scss">


</style>
